/**
 * Notification Center — shared SSE connection (see sharedStream.js for auth).
 * Independent of Relay — works whether or not a tenant has Relay enabled.
 */
import { createSharedStream } from '@/api/sharedStream';

export const subscribeNotifications = createSharedStream({
  path: '/api/notifications/stream',
  eventTypes: ['ready', 'notification.new'],
});
